import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  autoSize?: boolean | { minRows?: number; maxRows?: number };
  maxlength?: number;
  showCount?: boolean;
  allowClear?: boolean;
  status?: "" | "error" | "warning";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextareaInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: false },
    rows: { default: 4 },
    autoSize: { type: [Boolean, Object], default: false },
    maxlength: { default: undefined },
    showCount: { type: Boolean, default: false },
    allowClear: { type: Boolean, default: true },
    status: { default: "" }
  },
  emits: ["update:modelValue", "blur", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onBlur = (e: FocusEvent) => emit("blur", e);

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!

  return (_openBlock(), _createBlock(_component_a_textarea, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    rows: _ctx.rows,
    "auto-size": _ctx.autoSize,
    maxlength: _ctx.maxlength,
    "show-count": _ctx.showCount,
    "allow-clear": _ctx.allowClear,
    status: _ctx.status,
    class: "ant-textarea-input",
    onBlur: onBlur
  }, null, 8, ["value", "placeholder", "disabled", "rows", "auto-size", "maxlength", "show-count", "allow-clear", "status"]))
}
}

})